import styled from 'styled-components';

export const StyledDocResult = styled.span`
  color: gray;
  text-decoration: none;
  border-bottom: 1px gray dotted;
  cursor: pointer;
`;